import React from 'react';
import './Badge.scss';

export type BadgeVariant = 'default' | 'success' | 'warning' | 'danger' | 'info' | 'primary';
export type BadgeSize = 'small' | 'medium';

export interface BadgeProps {
  children: React.ReactNode;
  variant?: BadgeVariant;
  size?: BadgeSize;
  className?: string;
}

export const Badge: React.FC<BadgeProps> = ({
  children,
  variant = 'default',
  size = 'medium',
  className = '',
}) => {
  return (
    <span className={`badge badge--${variant} badge--${size} ${className}`}>
      {children}
    </span>
  );
};

// Status Badge - for common status indicators
export type StatusType =
  | 'active'
  | 'blocked'
  | 'verified'
  | 'unverified'
  | 'visible'
  | 'hidden'
  | 'free'
  | 'paid'
  | 'active_plan'
  | 'no_active_plan'
  | 'popular';

export interface StatusBadgeProps {
  status: StatusType;
  size?: BadgeSize;
  className?: string;
}

const STATUS_CONFIG: Record<StatusType, { label: string; variant: BadgeVariant }> = {
  active: { label: 'Active', variant: 'success' },
  blocked: { label: 'Blocked', variant: 'danger' },
  verified: { label: 'Verified', variant: 'success' },
  unverified: { label: 'Not Verified', variant: 'warning' },
  visible: { label: 'Visible', variant: 'success' },
  hidden: { label: 'Hidden', variant: 'warning' },
  free: { label: 'Free', variant: 'info' },
  paid: { label: 'Paid', variant: 'primary' },
  active_plan: { label: 'Active Plan', variant: 'success' },
  no_active_plan: { label: 'No Active Plan', variant: 'default' },
  popular: { label: 'Popular', variant: 'danger' },
};

export const StatusBadge: React.FC<StatusBadgeProps> = ({
  status,
  size = 'medium',
  className = '',
}) => {
  const config = STATUS_CONFIG[status];
  return (
    <Badge variant={config.variant} size={size} className={className}>
      {config.label}
    </Badge>
  );
};
